import PropTypes from 'prop-types'
import {useEffect, useState} from 'react'
import {Link as RouterLink, useLocation} from 'react-router-dom'
import {alpha, styled, useTheme} from '@material-ui/core/styles'
import {
  Box,
  Link,
  Button,
  Drawer,
  Typography,
  Avatar,
  Stack,
  Tooltip,
  CardActionArea,
  useMediaQuery,
  IconButton,
} from '@material-ui/core'
import Logo from '../../components/Logo'
import Scrollbar from '../../components/Scrollbar'
import NavSection from 'components/NavSection'
import {MHidden} from '../../components/@material-extend'
import SidebarConfigStore from './SidebarConfigStore'
import SidebarConfigEmployee from './SidebarConfigEmployee'
import useCollapseDrawer from 'utils/hooks/drawer'
import {DocIllustration} from '../../assets'
import discord_api from 'utils/api/discord'
import Bugsnag from '@bugsnag/js'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import storage from 'utils/storage'
import user_api from 'utils/api/users'
import getNavConfig from './SidebarConfigStore'
const DRAWER_WIDTH = 280
const COLLAPSE_WIDTH = 0

const RootStyle = styled('div')(({theme}) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    // Remove fixed width - let sx prop handle width completely
  },
}))

const AccountStyle = styled('div')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200],
}))

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
}

IconCollapse.propTypes = {
  onToggleCollapse: PropTypes.func,
  collapseClick: PropTypes.bool,
}

function IconCollapse({onToggleCollapse, collapseClick}) {
  return (
    <Tooltip title="Mini Menu">
      <CardActionArea
        onClick={onToggleCollapse}
        sx={{
          width: 18,
          height: 18,
          display: 'flex',
          cursor: 'pointer',
          borderRadius: '50%',
          alignItems: 'center',
          color: 'text.primary',
          justifyContent: 'center',
          border: 'solid 1px currentColor',
          ...(collapseClick && {
            borderWidth: 2,
          }),
        }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            bgcolor: 'currentColor',
            transition: (theme) => theme.transitions.create('all'),
            ...(collapseClick && {
              width: 0,
              height: 0,
            }),
          }}
        />
      </CardActionArea>
    </Tooltip>
  )
}

export default function DashboardSidebar({isOpenSidebar, onCloseSidebar, account}) {
  const {isCollapse, collapseClick, collapseHover, onHoverEnter, onHoverLeave} = useCollapseDrawer()
  const {pathname} = useLocation()
  const [myCompany, setMyCompany] = useState(false)
  const [myDocuments, setMyDocuments] = useState(false)

  const [myTraining, setMyTraining] = useState(false)
  

  // Check if current page is QR scan page - should behave like mobile
  const isQRScanPage = pathname === '/stores/biometric'

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, account])

  const load = async () => {
    const features = await user_api.get_features({store: account.company})
    if (features.data.length > 0) {

      features.data.forEach(feature => {
        feature.features.forEach(data => {
          
          if (data.feature === "My Documents") {
             setMyDocuments(true)
           }
           if (data.feature === "My Company") {
             setMyCompany(true)
           }
           if (data.feature === "Training And Development") {
            setMyTraining(true)
           }
        })
      })
    }
  }

  useEffect(() => {
    load()
  }, [])
  // Inside your component
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleHelpCenterClick = async (e) => {
    var message = ''
    message = prompt(
      'How can we help you? - <name/phone#/email - branch - [issue/feedback]>',
      'Input name/phone#/email - branch - [issue/problem/inquiry/feedback]',
    )

    if (message === null) return

    let params = JSON.stringify({
      username: 'Captain Sparkle',
      avatar_url: 'https://www.sparkles.com.ph/static/2629bb8535ba6ae5406fc9385dadc2e0/497c6/Spark--noodles.png',
      content: ` Time In Help - Version 2 \n**Issue:**\n ${message}`,
    })

    const result = await discord_api.send_message(params)

    if (!result.ok) {
      Bugsnag.notify(result)
      return alert('Unable to submit your request for assitances')
    }
    return alert('Thank you for your patience, we will contact you ASAP.')
  }
  // Add this handler in your component
  const handleToggleUIVersion = async () => {
    try {
      const current = localStorage.getItem('uiVersion') || 'old'
      const next = current === 'new' ? 'old' : 'new'
      console.log('🚀 ~ handleToggleUIVersion ~ account:', account)

      await user_api.set_ui_version(account._id, next)

      localStorage.setItem('uiVersion', next)

      window.location.reload()
    } catch (error) {
      console.error('UI version toggle failed', error)
      alert('Unable to switch UI version. Please try again.')
    }
  }


  const navConfig = getNavConfig(account, myCompany, myDocuments, myTraining);


  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          px: 2.5,
          pt: 3,
          pb: 2,
          ...(isCollapse && {
            alignItems: 'center',
          }),
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Box component={RouterLink} to="/" sx={{display: 'inline-flex'}}>
            <Logo isQRScanPage={isQRScanPage} />
          </Box>
          <MHidden width="lgUp">
            <IconButton onClick={onCloseSidebar}>
              <ChevronRightIcon sx={{color: 'black', fontSize: 30}} />
            </IconButton>
          </MHidden>
          {/* 
          <MHidden width="lgDown">
            {!isCollapse && <IconCollapse onToggleCollapse={onToggleCollapse} collapseClick={collapseClick} />}
          </MHidden> */}
        </Stack>
        {/* --- UI Toggle Button --- */}
        {!isCollapse && (
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={handleToggleUIVersion}
            sx={{alignSelf: 'flex-start'}}
          >
            {localStorage.getItem('uiVersion') === 'new' ? '⬅ Go back to Classic UI' : '✨ Try the New UI'}
          </Button>
        )}
        {isCollapse ? (
          <Avatar sx={{mx: 'auto', mb: 2}} src={account.image} />
        ) : (
          <Link underline="none" component={RouterLink} to={`/stores/app`}>
            <AccountStyle>
              <Avatar src={account.image} />
              <Box sx={{ml: 2}}>
                <Typography variant="subtitle2" sx={{color: 'text.primary'}}>
                  {account?.displayName}
                </Typography>
                <Typography variant="body2" sx={{color: 'text.secondary'}}>
                  {account?.role === 1 || account?.role >= 3 ? 'Store' : 'Employee'}
                </Typography>
              </Box>
            </AccountStyle>
          </Link>
        )}
      </Stack>

      {Array.isArray(navConfig) && <NavSection account={account} navConfig={navConfig} isShow={!isCollapse} />}

      <Box sx={{flexGrow: 1}} />
      {!isCollapse && (
        <Stack spacing={3} alignItems="center" sx={{px: 5, pb: 5, mt: 10, width: 1, textAlign: 'center'}}>
          <DocIllustration sx={{width: 1}} />

          <div>
            <Typography gutterBottom variant="subtitle1">
              Hi, {account?.displayName}
            </Typography>
            <Typography variant="body2" sx={{color: 'text.secondary'}}>
              Need help?
              <br /> Send us an message
            </Typography>
          </div>
          <Button variant="contained" onClick={() => handleHelpCenterClick()}>
            Contact Us
          </Button>
        </Stack>
      )}
    </Scrollbar>
  )

  return (
    <RootStyle
      sx={{
        width: {
          lg: isCollapse && !isQRScanPage ? COLLAPSE_WIDTH : DRAWER_WIDTH,
        },
        flexShrink: 0, // Move flexShrink to sx for consistency
        ...(collapseClick && {
          position: 'absolute',
        }),
        ...(isQRScanPage &&
          !isOpenSidebar && {
            width: 0,
          }),
      }}
    >
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: {width: '100%'},
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      {isQRScanPage ? (
        <MHidden width="lgDown">
          <Drawer
            open={isOpenSidebar}
            onClose={onCloseSidebar}
            variant="temporary"
            PaperProps={{
              sx: {
                width: isCollapse ? 0 : DRAWER_WIDTH,
                zIndex: (theme) => theme.zIndex.drawer + 1,
              },
            }}
          >
            {renderContent}
          </Drawer>
        </MHidden>
      ) : (
        <MHidden width="lgDown">
          <Drawer
            open
            variant="persistent"
            onMouseEnter={onHoverEnter}
            onMouseLeave={onHoverLeave}
            PaperProps={{
              sx: {
                width: isCollapse ? 0 : DRAWER_WIDTH,
                bgcolor: 'background.default',
                ...(isCollapse && {
                  width: COLLAPSE_WIDTH,
                }),
                ...(collapseHover && {
                  borderRight: 0,
                  backdropFilter: 'blur(6px)',
                  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
                  boxShadow: (theme) => theme.customShadows.z20,
                  bgcolor: (theme) => alpha(theme.palette.background.default, 0.88),
                }),
              },
            }}
          >
            {renderContent}
          </Drawer>
        </MHidden>
      )}
    </RootStyle>
  )
}
